




















































































import { Vue, Component } from "vue-property-decorator";
import { Tabbar, TabbarItem, Overlay } from "vant";
import bottonBar from "@/components/bottonBar.vue";
import dataShare from "@/views/mall/dataShare";
import btripServcice from "@/service/btripServcice";
import baseService from "@/service/baseService";
import UserService from "@/service/UserService";
import { categoryMap, ServiceType, YesOrNo } from "@/model/Base";
import _ from "lodash";
import { isOfw } from "@/utils/utils";
const ServiceTypes: any = {
  HotelService: 1407,
  FlightService: 1409,
  TrainService: 1470,
};
@Component({
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Overlay.name]: Overlay,
    bottonBar,
  },
  // filters: {},
})
export default class extends Vue {
  isPrivate = false;
  service = "";
  bookingType = "1529";
  TripRuleData: any[] = [];
  isShowBtripRule = false;
  Continents = [];
  get isOfwApp() {
    return isOfw();
  }

  getCategoryName(code: number) {
    let result: any = "";
    switch (code) {
      case 1127:
        result = this.$root.$t("mall_modules_producthome_guoji");
        break;
      case 1126:
        result = this.$root.$t("mall_modules_producthome_guonei");
        break;
      case 1409:
        result = this.$root.$t("mall_modules_producthome_jipiaofuwu");
        break;
      case 1407:
        result = this.$root.$t("mall_modules_producthome_jiudianfuwu");
        break;
      case 1470:
        result = this.$root.$t("mall_modules_producthome_huochefuwu");
        break;
      case YesOrNo.Yes:
        result = "是";
        break;
      case YesOrNo.No:
        result = "否";
        break;
      case 0:
        result = "不限制";
        break;
      case 1501:
        result = "相对最低价"; //, "相对最低价", "ControLowestPrice", 0),
        break;
      case 1502:
        result = "全天最低价"; //, "全天最低价", "DayLowestPrice", 0),
        break;
      case 1503:
        result = "时段最低价"; //, "时段最低价", "TimeAreaLowestPrice ", 0),
        break;
      case 1504:
        result = "航班最低价"; //, "全航班最低价", "FlightLowestPrice", 0),
        break;
    }
    return result;
  }
  // //computed
  mounted() {
    this.getTripRuleData();
    baseService
      .getZoneList({
        ZoneType: "1448",
      })
      .then(o => {
        if (o.isSucc) {
          this.Continents = o.result.entities;
        }
      });
  }

  //methods
  selectTravelType(value: string): void {
    this.bookingType = value;
    this.isPrivate = !this.isPrivate;
    dataShare.bookingType = this.bookingType;
  }
  getTripRuleData() {
    let data: any = { Users: [] };
    btripServcice.getTripRule(data).then((res: any) => {
      if (res.isSucc) {
        (this as any).TripRuleData = res.result;
        this.$emit("OneSelfs", res.result.OneSelf);
        this.getFlowInfo();
      }
    });
  }
  FlowInfoData: any = "";
  getFlowInfo() {
    let __self = this;
    _.forEach((this as any).TripRuleData.Roles, (item: any) => {
      let FlowID = item.FlowID;
      UserService.getFlowInfo(FlowID).then(function(json) {
        if (json.isSucc) {
          let FlowInfo: any = json.result;
          _.forEach(FlowInfo.Nodes, (i: any) => {
            let RoleInfo: any = [];
            _.forEach(i.Roles, t => {
              let FlowRole = t;
              let roleinfo = {
                RoleID: FlowRole.RoleID,
              };
              UserService.getRoleInfo(roleinfo).then(role => {
                if (role.isSucc) {
                  RoleInfo.push(role.result);
                }
              });
            });
            i.RoleInfo = RoleInfo;
          });
          __self.FlowInfoData = json.result;
        }
      });
    });
  }
  filterRoleInfo(node?: any) {
    let Roles = _.filter(node.Roles, o => {
      return o.DutyCode == "executer";
    });
    let Actives: any = [];
    _.forEach(Roles, o => {
      _.forEach(node.RoleInfo, m => {
        if (o.RoleID == m.RoleID) {
          Actives.push(m);
        }
      });
    });
    return Actives;
  }

  get ServeType() {
    let serveType = this.$route.meta.title;
    let serviceType: string = "";
    if (serveType) {
      serviceType = serveType.replace(serveType[0], serveType[0].toUpperCase()) + "Service";
    }
    return ServiceTypes[serviceType];
  }

  ServiceGrades = {
    FlightGrades: [
      {
        GradeID: 1500,
        GradeTitle: this.$root.$t("mall_modules_producthome_toudengcang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_toudengcang") as string,
        GradeNum: 0,
        GradeDiscount: 20,
      },
      {
        GradeID: 1498,
        GradeTitle: this.$root.$t("mall_modules_producthome_shangwucang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_shangwucang") as string,
        GradeNum: 1,
        GradeDiscount: 15,
      },
      {
        GradeID: 1496,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 2,
        GradeDiscount: 10,
      },
      {
        GradeID: 1859,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang9zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 3,
        GradeDiscount: 9,
      },
      {
        GradeID: 1857,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang8zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 4,
        GradeDiscount: 8,
      },
      {
        GradeID: 1855,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang7zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 5,
        GradeDiscount: 7,
      },
      {
        GradeID: 1853,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang6zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 6,
        GradeDiscount: 6,
      },
      {
        GradeID: 1851,
        GradeTitle: this.$root.$t("mall_modules_producthome_jingjicang5zhe") as string,
        GradeLabel: this.$root.$t("mall_modules_producthome_jingjicang") as string,
        GradeNum: 7,
        GradeDiscount: 5,
      },
    ],
  };

  filterServiceLevel(serviceType?: any, ServiceLevels?: any) {
    let __self = this;
    if (!ServiceLevels) {
      return;
    }
    let datas = ServiceLevels.split(/\n|,/g);
    let results = [];
    if (serviceType == ServiceType.FlightService) {
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i];
        let result = _.find(this.ServiceGrades.FlightGrades, o => data == o.GradeID);
        if (result) {
          results.push(result);
        }
      }
      let maxPrice = _.maxBy(results, o => o.GradeDiscount);
      if (maxPrice) {
        return maxPrice.GradeTitle;
      }
    }
    if (serviceType == ServiceType.TrainService) {
      for (let i = 0; i < datas.length; i++) {
        let data = datas[i];
        let result = categoryMap[data];
        if (result) {
          results.push(result);
        }
      }
      let maxPrice: any = _.minBy(results, (o: any) => o.CategoryID);
      if (maxPrice) {
        return maxPrice.CategoryTitle;
      }
    }
  }
  filterPrice(ServiceType?: any, Prices?: any, ApplyArea?: any) {
    let __self = this;
    let results = [];
    if (ApplyArea == 1127) {
      let minPrice = _.minBy(Prices, (Price: any) => {
        return Price.LimitPrice;
      });
      let maxPrice = _.maxBy(Prices, (Price: any) => {
        return Price.LimitPrice;
      });
      if (minPrice.LimitPrice != maxPrice.LimitPrice) {
        if (ServiceType == 1409) {
          minPrice.RuleDescribe = (__self.contincentName(minPrice.LimitRule) + minPrice.LimitPrice + this.$root.$t("mall_modules_producthome_yinei")) as string;
          maxPrice.RuleDescribe = ((this.$root.$t("mall_modules_producthome_bufenhangxian") as string) + maxPrice.LimitPrice + this.$root.$t("mall_modules_producthome_yinei")) as string;
        } else {
          minPrice.RuleDescribe = (__self.contincentName(minPrice.LimitRule) + minPrice.LimitPrice + this.$root.$t("mall_modules_producthome_yinei")) as string;
          maxPrice.RuleDescribe = ((this.$root.$t("mall_modules_producthome_bufenjiudian") as string) + maxPrice.LimitPrice + this.$root.$t("mall_modules_producthome_yinei")) as string;
        }
        results.push(minPrice, maxPrice);
      } else {
        minPrice.RuleDescribe = maxPrice.LimitPrice;
        results.push(minPrice);
      }
      return results;
    } else {
      if (Prices.length > 0) {
        if (ServiceType == 1409) {
          Prices[0].RuleDescribe = Prices[0].LimitPrice;
        }
        if (ServiceType == 1407) {
          _.forEach(Prices, (o: any) => {
            o.RuleDescribe = this.$root.$t("mall_modules_producthome_jichengshiyinei", [o.LimitRule, o.LimitPrice]);
          });
        }
        return Prices;
      }
    }
  }
  contincentName(val?: any) {
    let __self = this;
    var contin: any = _.find(__self.Continents, (o: any) => o.ContinentID == val);
    if (contin) {
      if (contin.ContinentName == "" || contin.ContinentName == null) {
        return __self.$t("mall.Other");
      }
      return contin.ContinentName;
    }
    return "-";
  }
  back() {
    history.back();
  }
}
